import { AdminUpdateJobDto } from '@betterleap/client';

const overrideMap = {
  [AdminUpdateJobDto.employmentType.PRN]: 'PRN',
};

/*
 * This converst the enum key to a UI string.
 * Example: 'FULL_TIME' -> 'Full Time'
 */
export const convertEnumKeyToUIString = (enumValue: string): string => {
  if (overrideMap[enumValue]) {
    return overrideMap[enumValue];
  }

  return enumValue
    .toLowerCase()
    .replace(/[_-]/g, ' ')
    .replace(/\b\w/g, (match) => match.toUpperCase());
};
